export default {"src":"/_next/static/media/0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca.37f21892.svg","height":181,"width":180,"blurWidth":0,"blurHeight":0};